import { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";

// storage 
import { localStorage } from "@/infrastructure/storage";

// features 
import Notification from "@/features/notification/Notification";

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState<boolean>(
    () => localStorage.get<boolean>("sidebar_collapsed") ?? false
  );
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = () => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.set("sidebar_collapsed", next);
      return next;
    });
  };

  const handleLogout = () => {
    navigate("/logout");
  };

  const pathTitleMap: Record<string, string> = {
    "/": "Dashboard",
    "/users": "Users",
    "/partners": "Partners",
    "/partner-requests": "Partner Requests",
    "/riders": "Riders",
    "/rider-requests": "Rider Requests",
    "/referrals": "Referrals",
    "/orders": "Orders",
    "/products": "Products",
    "/categories": "Categories",
    "/coupons": "Coupons",
    "/reviews/orders": "Reviews",
    "/supports": "Supports",
    "/bills": "Bills",
    "/settings": "Settings",
    "/earning-report": "Earning Report",
  };

  const title = pathTitleMap[location.pathname] || "Admin Panel";

  useDocumentTitle(title);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar collapsed={collapsed} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Topbar */}
        <header
          style={{
            height: "60px",
            backgroundColor: "#111",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
            gap: '5px'
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <button
              onClick={handleToggle}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontSize: "1.2rem",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-list"></i>
            </button>
            <span style={{ fontWeight: "bold", letterSpacing: "1px" }}>
              {title}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
            }}
          >
            {/* Notifications popup screen  */}
            <Notification />

            <button
              onClick={handleLogout}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontSize: "1.2rem",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-power"></i>
            </button>

          </div>

        </header>

        {/* Main Content */}
        <main style={{ flex: 1, overflowY: "auto", backgroundColor: "#e4f2fd", minWidth: 0, }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
